import { h } from 'preact'
import BanksSelect from './banks-select'
import { BankData } from 'src/assets/scripts/models/market'

interface SingleChartProps {
  bankName: string
  isBankSelect?: boolean
  handleSetClickedBank?: any
  offerPercentage: string
  banksData: BankData[]
}

const SingleChart = ({
  handleSetClickedBank,
  isBankSelect,
  bankName,
  offerPercentage,
  banksData,
}: SingleChartProps) => {
  return (
    <div className="calculator-chart__single-chart-holder">
      {isBankSelect ? (
        <BanksSelect
          handleSetClickedBank={handleSetClickedBank}
          banksData={banksData}
          bankName={bankName}
        />
      ) : (
        <p className={'calculator-chart__chart-title'}>{bankName}</p>
      )}
      <div className="calculator-chart__chart-holder">
        <div
          className="calculator-chart__chart-percetage-line"
          style={{ width: `${offerPercentage}%` }}
        />
      </div>
    </div>
  )
}

export default SingleChart
